import script from "./ControlBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlBtn.vue?vue&type=script&setup=true&lang=js"

import "./ControlBtn.vue?vue&type=style&index=0&id=c414c11c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c414c11c"]])

export default __exports__